// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setRecentlyViewedPatients,
  resetSearchPatientList
} from 'src/store/modules/patients'

const initialState = {
  recentlyViewed: []
}

export default handleActions(
  {
    [setRecentlyViewedPatients](state, { payload: recentlyViewed }) {
      return {
        ...state,
        recentlyViewed
      }
    },

    [resetSearchPatientList]() {
      return initialState
    }
  },
  initialState
)
